// extracted by mini-css-extract-plugin
export default {"wrapper":"Carousel_wrapper__kmR7Q","pages":"Carousel_pages__PoIQs"};